import { createApp } from 'vue'

import '@fontsource-variable/inter'
import { VueQueryPlugin } from '@tanstack/vue-query'
import 'vue-sonner/style.css'

import App from '#app/App.vue'
import '#app/assets/style/index.css'
import router from '#app/router'
import auth0 from '#app/services/auth0'
import { queryClient } from '#app/services/query'
import { toast } from '#ui/sonner'
import { errorMessage } from '#utils/errors'

const app = createApp(App)

app.config.errorHandler = (error) => {
  console.error(error)
  toast.error(errorMessage(error))
}

app
  .use(router)
  .use(auth0)
  .use(VueQueryPlugin, {
    queryClient,
    enableDevtoolsV6Plugin: import.meta.env.MODE === 'development',
  })

app.mount('#app')
